import RequestStatus from "../model/RequestStatus";
import {GetBulkProductSearchDataResponse} from "../model/ProductMatch";
import {
    BULK_PRODUCT_DATA_QUERY_FAILED,
    BULK_PRODUCT_DATA_QUERY_START,
    BULK_PRODUCT_DATA_QUERY_SUCCESS,
    BulkProductDataQueryStartAction,
    GetBulkProductDataQueryComplete
} from "src/actions/BulkProductSearchAction";

const initialState: GetBulkProductSearchDataResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    productData: null,
};

export default (
    state: GetBulkProductSearchDataResponse = initialState,
    action: GetBulkProductDataQueryComplete | BulkProductDataQueryStartAction
): GetBulkProductSearchDataResponse => {
    switch (action.type) {
        case BULK_PRODUCT_DATA_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                productData: null,
                // @ts-ignore
                request: action
            };
        case BULK_PRODUCT_DATA_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                productData: "productData" in action ? action.productData : null,
                request: state.request
            };
        case BULK_PRODUCT_DATA_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                productData: null,
                request: state.request
            };
        default:
            return state;
    }
};

